import { render, staticRenderFns } from "./SponsoredPaids.vue?vue&type=template&id=0277558e"
import script from "./SponsoredPaids.vue?vue&type=script&lang=js"
export * from "./SponsoredPaids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports